import gql from "graphql-tag";

export const MY_LEAVE_ADD_LEAVE_TYPE_FILTER = gql`
  mutation addLeaveTypeFilter($code: String!) {
    addLeaveTypeFilter(code: $code)
  }
`;
